/**
 * Compact Indian Rupee tick formatter for chart axes.
 * Always outputs the smallest readable form, with at most 1 decimal and
 * trailing zeros trimmed:
 *   84,532       → ₹85K     (>=1K)
 *   1,00,000     → ₹1L      (>=1L)
 *   25,00,000    → ₹25L
 *   89,92,265.73 → ₹89.9L
 *   1,00,00,000  → ₹1Cr
 *   2,06,60,141  → ₹2.1Cr
 */
export function compactInr(v) {
    const n = Number(v) || 0;
    const sign = n < 0 ? '-' : '';
    const abs = Math.abs(n);

    const trim = (x) => x.toFixed(1).replace(/\.0$/, '');

    if (abs >= 1e7) return `${sign}₹${trim(abs / 1e7)}Cr`;
    if (abs >= 1e5) return `${sign}₹${trim(abs / 1e5)}L`;
    if (abs >= 1e3) return `${sign}₹${Math.round(abs / 1e3)}K`;   // K stays integer for readability
    return `${sign}₹${Math.round(abs)}`;
}
